/** 各站点提交后记住「已填过问卷」，避免再次自动弹出 */
export function getQuestionnaireSubmittedStorageKey(locale: string): string {
    // US 保持旧 key，兼容已提交用户的 localStorage
    if (locale === 'us') return 'questionnaireSubmittedUsHome';
    return `questionnaireSubmitted_${locale}`;
}
